const filters = [
  { key: 'categories', label: "Secteurs d'activité" },
  { key: 'qualities', label: 'Qualités requises' },
  { key: 'interests', label: "Centres d'intérêt" },
  { key: 'study_levels', label: "Niveau d'études" }
];

const FilterButtons = ({ activeFilter, setActiveFilter }) => {
  return (
    <div className="flex gap-2 mb-2 pt-5">
      {filters.map(f => (
        <button
          key={f.key}
          className={`px-2 md:px-4 py-2 rounded-xl ${activeFilter === f.key ? 'bg-teal-500' : 'bg-gray-800 hover:bg-gray-700'}`}
          onClick={() => setActiveFilter(f.key)}
        >
          {f.label}
        </button>
      ))}
    </div>
  );
};

export default FilterButtons;
